import type { AdminBuild } from "../../lib/api/admin";

export function BuildRetentionNotice({ build }: { build: AdminBuild }) {
  return <span className="muted">{build.siteId ? "Kept in this site's history" : build.previewUrl ? "Retained preview" : "Retained build record"}</span>;
}
